<template>
<div>
    <div class="row mb-3">
        <div>
            <label class="form-label">고시원 대표 사진
                <span class="text-danger">*</span>
                &nbsp;&nbsp;<i class="mdi mdi-information-outline font-18 align-middle me-1 text-primary" data-bs-toggle="tooltip" data-bs-placement="right" data-bs-html="true" :data-bs-title="thumnauilImgMsg
                "></i>
            </label>
            <input class="form-control" type="file" id="thumnauilImg" accept="image/*" @change="selectImage($event)">
        </div>
    </div>
    <div class="row mb-3">
        <div class="col text-center mb-3" v-if="kosiwon.thumbnail_url">
            <div class="image-container">
                <img :src="kosiwon.thumbnail_url" class="img-fluid kosiwon-thumbnail-img" alt="Kosiwon Thumbnail Image" />
                <div class="button-group">
                    <button type="button" class="btn btn-primary btn-sm btn-sm-custom" @click="openUpload(`thumnauilImg`)">수정</button>
                    <button type="button" class="btn btn-danger btn-sm btn-sm-custom" @click="deleteImage()">삭제</button>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <div>
            <label class="form-label">고시원 사진 정보 (10장 이내)
                <span class="text-danger">*</span>
                &nbsp;&nbsp;<i class="mdi mdi-swap-horizontal"></i>
                &nbsp;&nbsp;<i class="mdi mdi-information-outline font-18 align-middle me-1" data-bs-toggle="tooltip" data-bs-placement="right" data-bs-html="true" :data-bs-title="kosiwonImgMsg
                " style="color:#727cf5;"></i>
            </label>
            <input class="form-control" type="file" id="kosiwonImg" multiple @change="selectImage($event, null)">
        </div>
    </div>
    <draggable class="row mb-3" v-model="kosiwon.categories[0].groups[0].images" v-if="kosiwon.categories[0].groups[0].images.length > 0" :animation="500" easing="cubic-bezier">
        <div class="col-md-3 col-6 text-center mb-3" v-for="(item, idx) in kosiwon.categories[0].groups[0].images" :key="`kosiwon_image_${idx}`">
            <div class="image-container">
                <i class="mdi mdi-swap-horizontal kosiwon-info-img-swap"></i>
                <img :src="item.image_url" class="img-fluid kosiwon-info-img" alt="Kosiwon Image" />
                <div class="button-group">
                    <input type="file" :id="`kosiwonImg_${idx}`" accept="image/*" style="display:none;" @change="selectImage($event, idx)" />
                    <button type="button" class="btn btn-primary btn-sm btn-sm-custom" @click="openUpload(`kosiwonImg_${idx}`)">수정</button>
                    <button type="button" class="btn btn-danger btn-sm btn-sm-custom" @click="deleteImage(idx)">삭제</button>
                </div>
            </div>
        </div>
    </draggable>
    <div class="row mb-3" v-else></div>

    <ul class="list-inline wizard mb-0">
        <li class="list-inline-item float-end">
            <button type="button" class="btn btn-info" @click="$emit('open-confirm-modal')">{{ btnText }}</button>
        </li>
    </ul>
</div>
</template>

<script>
import common from "@/mixins/common.js";
import draggable from "vuedraggable";

export default {
    components: {
        draggable
    },
    props: [
        "kosiwon",
        "btnText"
    ],
    mixins: [
        common
    ],
    data() {
        return {
            thumnauilImgMsg: "고시원 지도 검색 시,<br/>썸네일 이미지에 적용됩니다.<br/>" +
                "대표 사진은 가급적이면<br/>방 전체 사진을 올려주세요.<br/>" +
                "<img src='https://s3.ap-northeast-2.amazonaws.com/kosirock.kosiwons.image/temp/9656ed484072f2157691ff713207d2f94827b4e18c3f0c2887093bf0660f138e.png' />",

            kosiwonImgMsg: "고시원 상세 보기 시,<br/>상단의 이미지에 적용됩니다.<br/><br/>" +
                "또한, 이미지를 드래그하여<br/>순서를 변경할 수 있습니다."
        }
    },
    methods: {
        openUpload(id) {
            document.getElementById(id).click();
        },
        async selectImage(event, idx) {

            const files = event.target.files;
            const sendData = new FormData();

            if (!files || files.length === 0) {
                return;
            }

            const isThumbnail = (idx === undefined) && files.length == 1; // 썸네일 사진인지 검사 (단일, 다중 파일인지)
            const isSingleUpdate = idx != null || isThumbnail; // 단일 수정이나, 썸네일인 경우 Check
            const totalCnt = files.length + this.kosiwon.categories[0].groups[0].images.length; // 현재 파일 사진 수 + 이미 업로드 된 사진 수

            // 사진 수 10장 제한 (단일 이미지 및 썸네일 이미지 수정일 경우에는 제외)
            if (!isSingleUpdate && totalCnt > 10) {
                alert("고시원 사진은 최대 10장까지 사진 첨부가 가능합니다.");
                return;
            }

            for (let i = 0; i < files.length; i++) {
                if (!files[i].type.includes("image")) {
                    alert("고시원 사진은 이미지 파일만 등록 가능합니다.");
                    return;
                }
                sendData.append("filedata", files[i]);
            }

            try {
                this.loadingOverlay(true);

                const result = await this.axios.post("/upload/tempUpload", sendData);

                if (isThumbnail) {
                    this.kosiwon.thumbnail_url = result.data[0];
                } else {
                    if (isSingleUpdate) {
                        this.kosiwon.categories[0].groups[0].images[idx].image_url = result.data[0];
                    } else {
                        result.data.forEach(url => {
                            this.kosiwon.categories[0].groups[0].images.push({
                                image_url: url
                            });
                        });
                    }
                }
            } catch (error) {
                console.log(error);
                alert("이미지 업로드 중 예기치 못한 에러가 발생하였습니다.\n다시 시도해주세요.");
            } finally {
                this.loadingOverlay(false);
            }
        },
        deleteImage(idx) {
            if (confirm("해당 이미지를 삭제하시겠습니까?")) {
                if (idx === undefined) {
                    this.kosiwon.thumbnail_url = null;
                } else {
                    this.kosiwon.categories[0].groups[0].images.splice(idx, 1);
                }
            }
        }
    }
}
</script>

<style>
.kosiwon-thumbnail-img {
    max-height: 400px;
    border: 1px solid lightgray;
}

.kosiwon-info-img {
    max-height: 200px;
    border: 1px solid lightgray;
}

.kosiwon-info-img-swap {
    position: absolute;
    top: 10px;
    left: 10px;
    font-size: 20px;
    color: gray;
}

.tooltip-inner img {
    width: 100%;
    height: auto;
}
</style>
